import { Suspense } from 'react';
import { InboxClient } from './inbox-client';

export default function SellerInboxPage() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-ink">Inbox</h1>
      <Suspense fallback={<div className="text-sm text-forest/60">Loading…</div>}>
        <InboxClient />
      </Suspense>
    </div>
  );
}
